import { Draggable, Droppable } from '@hello-pangea/dnd'
import cx from 'helpers/cx'

import Item from './Item'
import styles from './List.module.css'

type ItemType = {
    guid: string
    [key: string]: any
}

type Props = {
    editMode: boolean
    containerGuid: string
    items: ItemType[]
    depth: number
    [key: string]: any
}

const List = ({ editMode, containerGuid, items, depth, ...rest }: Props) => (
    <Droppable
        droppableId={`droppable-${containerGuid}`}
        type={containerGuid}
        items={items as any}
        isDropDisabled={!editMode}
        {...({} as any)}
    >
        {(provided, snapshot) => {
            return (
                <>
                    <ul
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        className={cx(
                            styles.wrapper,
                            snapshot.isDraggingOver && styles.isDraggingOver,
                        )}
                    >
                        {items.map((item, i) => (
                            <Draggable
                                index={i}
                                key={item.guid}
                                draggableId={item.guid}
                                isDragDisabled={!editMode}
                            >
                                {(provided) => (
                                    <li
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                    >
                                        <Item
                                            item={
                                                {
                                                    ...item,
                                                    title:
                                                        item.title || item.guid,
                                                } as any
                                            }
                                            editMode={editMode}
                                            depth={depth}
                                            {...rest}
                                        />
                                    </li>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </ul>
                </>
            )
        }}
    </Droppable>
)

export default List
